module.exports = __webpack_public_path__ + "static/media/ending-theme.a429dfdf.mp3";